import { StyledIconLink, LinkText } from '../Link';
import { QuickLinkItem } from './QuickLinkItem';
import { EmailIcon } from '../Icon';

export interface IQuickLinkEmailProps {
	title: string;
	address: string;
}

export function QuickLinkEmail({ title, address }: IQuickLinkEmailProps) {
	return (
		<QuickLinkItem>
			<StyledIconLink href={`mailto:${address}`} target="_blank">
				<LinkText>{title}</LinkText>
				<EmailIcon variation="highlight" />
			</StyledIconLink>
		</QuickLinkItem>
	);
}
